import type { ExplicitAddress } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { useQuery } from '@tanstack/react-query';
import { RefetchInterval } from '@ui/config/ui';
import { useSDK } from '@ui/utils';
import { Fraction } from 'bi-fraction';

export const useBondingCurveTradingGasFee = ({
  fromAmount,
  bondingTokenAddress,
  type,
  enabled,
}: {
  fromAmount: Fraction;
  bondingTokenAddress: ExplicitAddress;
  type: 'buy' | 'sell';
  enabled?: boolean;
}) => {
  const sdk = useSDK();
  const provider = currentWallet.useProvider();

  return useQuery({
    queryKey: [
      'useBondingCurveTradingGasFee',
      fromAmount,
      bondingTokenAddress,
      type,
    ],
    queryFn: async () => {
      const signer = await provider?.getSigner();
      if (!signer) return { gasFee: Fraction.ZERO, success: false };
      const bondingCurveModule = sdk.getBondingCurveModule(signer);
      const estimate = await bondingCurveModule.estimateGasForTrade(
        fromAmount,
        bondingTokenAddress,
        type,
      );
      return estimate;
    },
    refetchInterval: RefetchInterval.Normal,
    enabled: !!provider && enabled !== false && fromAmount.gt(0),
  });
};
